module.exports = __webpack_public_path__ + "img/55.6a24bd90.jpg";